export const getShow = state => state?.modal?.show
export const getModalData = state => state?.modal?.data
